<ng-container *ngIf="environmentVariables?.ENABLE_STATIC_MENU">
    <div class="static-menu">
        <nav class="app-nav" *ngIf="CategoriesMenu?.length">
            <ul
                id="app-nav-list-menu2"
                class="app-nav-list my-0"
                [ngClass]="{ 'hide-menu': clickedItem }"
                (mouseleave)="clickedItem = false"
            >
                <li class="app-nav-item">
                    <a
                        (mouseleave)="clickedItem = false"
                        class="nav-link main all-caps"
                        routerLinkActive="active-link"
                        [routerLink]="['/' + lang + '/']"
                    >
                        {{ "header.home" | translate }}
                    </a>
                </li>
                <li
                    class="app-nav-item mega"
                    *ngFor="let item of CategoriesMenu; let i = index"
                >
                    <ng-container>
                        <a
                            class="nav-link main"
                            routerLinkActive="active-link"
                            (click)="
                                handleCategoryRouting({
                                     category_slug: item?.slug,
                                    category_id: item?.id,
                                    category_name: item?.name_en
                                })
                            "
                            (mouseleave)="clickedItem = false"
                        >
                            {{
                                (lang == "en" ? item?.name_en : item?.name_ar)
                                    | translate
                            }}
                        </a>
                    </ng-container>

                    <ul
                        class="sub-menu main-submenu dynamic-menu  static-menu-full-width"  
                        [ngClass]="{ 'sub-menu-ar': lang == 'ar' }"
                    >
                        <div class="menu-groups-container">
                            <li
                                *ngFor="let group of item?.groups"
                                [class.new-gird-group]="item.groups.length <= 1"
                            >
                                <a
                                    class="nav-link header"
                                    (click)="
                                        handleGroupRouting({
                                            category_id: item?.id,
                                            group_id: group?.id,
                                            category_slug: item?.slug,
                                            group_slug: group?.slug,
                                            group_name: group?.name
                                        });
                                        clickedItem = true
                                    "
                                >
                                    {{
                                        lang == "en"
                                            ? group?.name
                                            : group?.name_ar
                                    }}
                                </a>
                                <ul class="sub-menu">
                                    <li
                                        *ngFor="
                                            let subcategory of group?.sub_categories;
                                            let index = index
                                        "
                                    >
                                        <a
                                            class="nav-link"
                                            (click)="handleSubCategoryRouting({
                                            category_id: item?.id,
                                            group_id: group?.id,
                                            category_slug: item?.slug,
                                            group_slug: group?.slug,
                                            sub_category_slug:subcategory?.slug,
                                            sub_category_id:subcategory?.id,
                                            group_name: group?.name
                                            }); clickedItem = true"
                                        >
                                            {{
                                                lang == "en"
                                                    ? subcategory?.name
                                                    : subcategory?.name_ar
                                            }}
                                        </a>
                                    </li>
                                    <li
                                        class="view-more-items"
                                        *ngIf="
                                            group?.sub_categories.length > 11
                                        "
                                    >
                                        <a
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                group_id: group?.slug
                                            }"
                                        >
                                            {{
                                                "home_Page.viewAll" | translate
                                            }}
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <!-- <li *ngIf="i == 0 || i == 1">
                                <a
                                    *ngIf="i == 0 || i == 1"
                                    class="nav-link header"
                                    routerLinkActive="active-link"
                                    [routerLink]="['/' + lang + '/products']"
                                    (click)="clickedItem = true"
                                    [queryParams]="{
                                        category_id: item?.id,
                                        category_name: item?.name
                                    }"
                                >
                                    {{ "header.shopByPrice" | translate }}
                                </a>
                                <ul *ngIf="i == 0 || i == 1" class="sub-menu">
                                    <li>
                                        <a
                                            *ngIf="i != 1"
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_to: 999,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFromLess1000"
                                                    | translate
                                            }}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            *ngIf="i != 1"
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_from: 1000,
                                                price_to: 2999,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFrom1000to2999"
                                                    | translate
                                            }}
                                        </a>
                                        <a
                                            *ngIf="i != 0"
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_to: 2999,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFromLess3000"
                                                    | translate
                                            }}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_from: 3000,
                                                price_to: 5999,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFrom3000to5999"
                                                    | translate
                                            }}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_from: 6000,
                                                price_to: 10000,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFrom6000to10000"
                                                    | translate
                                            }}
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="nav-link"
                                            (click)="clickedItem = true"
                                            [routerLink]="[
                                                '/' + lang + '/products'
                                            ]"
                                            [queryParams]="{
                                                category_id: item?.id,
                                                price_from: 10001,
                                                category_name: item?.name
                                            }"
                                        >
                                            {{
                                                "header.priceFromMore10000"
                                                    | translate
                                            }}
                                        </a>
                                    </li>
                                </ul>
                            </li> -->
                        </div>
                        <div
                            class="preview-image"
                            *ngIf="item?.groups.length <= 3"
                        >
                            <img
                                loading="lazy"
                                [src]="item.image"
                                [alt]="item?.name"
                                onError="this.src='./assets/images/placeholder200.jpg';"
                                default="./assets/images/placeholder200.jpg"
                                style="width:100%"
                            />
                        </div>
                    </ul>
                </li>

                <li class="app-nav-item">
                    <a
                        class="nav-link main has-link"
                        (click)="clickedItem = true"
                        routerLinkActive="active-link"
                        (mouseleave)="clickedItem = false"
                        [routerLink]="['/' + lang + '/products/deals']"
                        [queryParams]="{sort:'high-discount'}"
                    >
                        {{ "deals" | translate }}
                    </a>
                </li>

                <li *ngIf="environmentVariables?.enable_prescription">
                    <a
                        class="nav-link main"
                        (click)="clickedItem = true"
                        [routerLink]="['/' + lang + '/prescriptions']"
                    >
                        {{ "prescription.medicalPrescription" | translate }}
                    </a>
                </li>
            </ul>
        </nav>

        <nav class="app-nav" *ngIf="!CategoriesMenu?.length">
            <ul class="app-nav-list">
                <li class="app-nav-item" *ngFor="let fake of fakeArray">
                    <div class="animate-shimmer shimmer-container"></div>
                </li>
            </ul>
        </nav>
    </div>
</ng-container>

<ng-container
    *ngIf="
        (!environmentVariables?.ENABLE_STATIC_MENU &&
            !environmentVariables?.ENABLE_MULTI_INVENTORY) ||
        (environmentVariables?.ENABLE_MULTI_INVENTORY &&
            (environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup == 'both'  ||
            environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup == 'area'
            )&&
            (user?.branch || user?.area))
    "
>
    <div
        [ngClass]="{
            'container pl-0':
                environmentVariables?.SLIDER_THEME_TYPE == 'container'
        }"
    >
        <div class="dynamic-menu">
            <nav
                class="app-nav"
                *ngIf="!loadingMenu && testData.level1"
                [ngClass]="{
                    'd-none':
                        !environmentVariables?.ENABLE_MENU_AS_CARDS ||
                        !showcards
                }"
                (click)="updateColorsTest()"
            >
                <ul
                    id="app-nav-list-menu"
                    class="app-nav-list my-0 py-2"
                    [ngClass]="{
                        'hide-menu': clickedItem,
                        'hide-scrollbar':
                            environmentVariables?.ENABLE_MENU_AS_CARDS
                    }"
                    (mouseleave)="clickedItem = false"
                >
                    <li
                        class="app-nav-item test-menu-cards mt-1 p-2"
                        [ngClass]="{
                            mega: levelOneItem?.level2?.length > 0,
                            'margin-for-img-only': levelOneItem.level1_text
                        }"
                        *ngFor="
                            let levelOneItem of testData.level1;
                            let i = index
                        "
                    >
                        <img
                            loading="lazy"
                            *ngIf="levelOneItem.level1_text"
                            class="single-card-menu mx-1 menu-img-only border-0"
                            [src]="levelOneItem?.level1_card_image"
                            alt="main section image"
                            (click)="navigateToLink(levelOneItem.link)"
                            onError="this.src='./assets/images/placeHolder400x400.png';"
                            default="./assets/images/placeholder200.jpg"
                        />

                        <div
                            class="single-card-menu text-with-label-card"
                            *ngIf="!levelOneItem.level1_text"
                        >
                            <span
                                [ngStyle]="{
                                    color: levelOneItem?.label_text_color
                                        ? levelOneItem?.label_text_color
                                        : '#248A3D',
                                    background:
                                        levelOneItem?.label_text_backround_color
                                            ? levelOneItem?.label_text_backround_color
                                            : '#DEEEE2'
                                }"
                                class="card-menu-label fs-12"
                                *ngIf="
                                    levelOneItem.label_text_en && lang === 'en'
                                "
                            >
                                {{ levelOneItem.label_text_en }}
                            </span>
                            <span
                                [ngStyle]="{
                                    color: levelOneItem?.label_text_color
                                        ? levelOneItem?.label_text_color
                                        : '#248A3D',
                                    background:
                                        levelOneItem?.label_text_backround_color
                                            ? levelOneItem?.label_text_backround_color
                                            : '#DEEEE2'
                                }"
                                class="card-menu-label fs-12"
                                *ngIf="
                                    levelOneItem.label_text_ar && lang === 'ar'
                                "
                            >
                                {{ levelOneItem.label_text_ar }}
                            </span>

                            <img
                                loading="lazy"
                                class="mt-3"
                                [src]="levelOneItem?.level1_card_image"
                                alt="main section image"
                                (click)="navigateToLink(levelOneItem.link)"
                                onError="this.src='./assets/images/placeHolder400x400.png';"
                                default="./assets/images/placeholder200.jpg"
                            />
                            <a
                                class="nav-link main has-link line-height-82"
                                routerLinkActive="active-link"
                                (click)="navigateToLink(levelOneItem.link)"
                                (mouseleave)="clickedItem = false"
                            >
                                <span class="text-truncate-one-line">
                                    {{
                                        lang == "en"
                                            ? levelOneItem?.name
                                            : levelOneItem?.name_ar
                                        
                                    }}
                                    <!-- <span
                                        *ngIf="
                                            (lang == 'en'
                                                ? levelOneItem?.name
                                                : levelOneItem?.name_ar
                                            ).length > 10
                                        "
                                    >
                                        ...
                                    </span> -->
                                </span>
                            </a>
                        </div>

                        <div
                            class="sub-menu main-submenu dynamic-menu top-200"
                            [ngClass]="{
                                'sub-menu-ar': lang == 'ar',
                                'box-shaow-none':
                                    environmentVariables?.ENABLE_MENU_AS_CARDS,
                                'sub-menu-left':
                                    levelOneItem.menu_fixed_width > 95
                            }"
                            [ngStyle]="{
                                padding:
                                    levelOneItem.menu_padding +
                                    levelOneItem.menu_padding_metric,
                                width:
                                    levelOneItem.menu_fixed_width +
                                    levelOneItem.menu_fixed_width_metric
                            }"
                        >
                            <ng-container
                                *ngIf="
                                    levelOneItem?.level2?.length > 0 &&
                                        levelOneItem?.levels_length == 3;
                                    else simpleMenu
                                "
                            >
                                <div class="menu-items">
                                    <ul
                                        class="sub-menu-items-container"
                                        [ngClass]="{
                                            'submenu-with-gallery':
                                                levelOneItem?.level1_gallery_images &&
                                                levelOneItem
                                                    ?.level1_gallery_images
                                                    ?.length > 0
                                        }"
                                    >
                                        <li
                                            class="sub-level-items-container"
                                            [ngClass]="
                                                levelOneItem.fixed_width
                                                    ? 'fixed-width'
                                                    : ''
                                            "
                                            [ngStyle]="{
                                                width:
                                                    levelOneItem.fixed_width +
                                                    levelOneItem.fixed_width_metric
                                            }"
                                            *ngFor="
                                                let levelTwoItem of levelOneItem.level2
                                            "
                                        >
                                            <div class="sub-level-items">
                                                <img
                                                    loading="lazy"
                                                    *ngIf="
                                                        levelOneItem.level2_image &&
                                                        levelTwoItem.image
                                                    "
                                                    [src]="levelTwoItem.image"
                                                    alt="secondary section image"
                                                />
                                                <div class="menu-section-body">
                                                    <span
                                                        class="second-level-nav-link position-relative"
                                                        [ngClass]="{
                                                            'has-link':
                                                                levelTwoItem.link,
                                                            'config-font-family':
                                                                environmentVariables?.ENABLE_FONT_FAMILY_OVERWRITE &&
                                                                lang == 'en'
                                                        }"
                                                        (click)="
                                                            navigateToLink(
                                                                levelTwoItem.link,
                                                                levelOneItem.link,
                                                                levelOneItem
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            class="level-tow-text"
                                                        >
                                                            {{
                                                                (lang == "en"
                                                                    ? levelTwoItem?.name
                                                                    : levelTwoItem?.name_ar
                                                                ) | translate
                                                            }}
                                                        </span>

                                                        <span
                                                            [ngStyle]="{
                                                                color: levelTwoItem?.group_label_text_color
                                                                    ? levelTwoItem?.group_label_text_color
                                                                    : '#248A3D',
                                                                background:
                                                                    levelTwoItem?.group_label_text_backround_color
                                                                        ? levelTwoItem?.group_label_text_backround_color
                                                                        : '#DEEEE2'
                                                            }"
                                                            class="mx-3 group-label-text"
                                                            *ngIf="
                                                                lang === 'en' &&
                                                                levelTwoItem.group_label_text_en
                                                            "
                                                        >
                                                            {{
                                                                levelTwoItem?.group_label_text_en
                                                            }}
                                                        </span>
                                                        <span
                                                            [ngStyle]="{
                                                                color: levelTwoItem?.group_label_text_color
                                                                    ? levelTwoItem?.group_label_text_color
                                                                    : '#248A3D',
                                                                background:
                                                                    levelTwoItem?.group_label_text_backround_color
                                                                        ? levelTwoItem?.group_label_text_backround_color
                                                                        : '#DEEEE2'
                                                            }"
                                                            class="mx-3 group-label-text"
                                                            *ngIf="
                                                                levelTwoItem.group_label_text_ar &&
                                                                lang == 'ar'
                                                            "
                                                        >
                                                            {{
                                                                levelTwoItem?.group_label_text_ar
                                                            }}
                                                        </span>
                                                    </span>

                                                    <ul class="mt-4">
                                                        <li
                                                            class="third-level-nav-link"
                                                            [ngStyle]="{
                                                                'line-height':
                                                                    levelOneItem.level3_items_spacing +
                                                                    levelOneItem.level3_items_spacing_metric
                                                            }"
                                                            *ngFor="
                                                                let levelThreeItem of levelTwoItem.level3
                                                            "
                                                            (click)="
                                                                navigateToLink(
                                                                    levelThreeItem.link,
                                                                    null,
                                                                    levelOneItem
                                                                )
                                                            "
                                                            [ngClass]="{
                                                                'has-link':
                                                                    levelThreeItem.link
                                                            }"
                                                        >
                                                            <div
                                                                class="view-more"
                                                                *ngIf="
                                                                    levelThreeItem.highlighted;
                                                                    else seeMoreLink
                                                                "
                                                            >
                                                                <img
                                                                    loading="lazy"
                                                                    *ngIf="
                                                                        levelOneItem.level3_image &&
                                                                        levelThreeItem.image
                                                                    "
                                                                    [src]="
                                                                        levelThreeItem.image
                                                                    "
                                                                    alt="item images"
                                                                />
                                                                <!-- - -->
                                                                {{
                                                                    (lang ==
                                                                    "en"
                                                                        ? levelThreeItem?.name
                                                                        : levelThreeItem?.name_ar
                                                                    )
                                                                        | translate
                                                                }}
                                                            </div>
                                                            <ng-template
                                                                #seeMoreLink
                                                            >
                                                                <img
                                                                    loading="lazy"
                                                                    *ngIf="
                                                                        levelOneItem.level3_image &&
                                                                        levelOneItem.level3_image &&
                                                                        levelThreeItem.image
                                                                    "
                                                                    [src]="
                                                                        levelThreeItem.image
                                                                    "
                                                                    alt="item images"
                                                                />
                                                                {{
                                                                    (lang ==
                                                                    "en"
                                                                        ? levelThreeItem?.name
                                                                        : levelThreeItem?.name_ar
                                                                    )
                                                                        | translate
                                                                }}
                                                                <span
                                                                    [ngStyle]="{
                                                                        color: levelThreeItem?.subCategory_label_text_color
                                                                            ? levelThreeItem?.subCategory_label_text_color
                                                                            : '#248A3D',
                                                                        background:
                                                                            levelThreeItem?.subCategory_label_text_backround_color
                                                                                ? levelThreeItem?.subCategory_label_text_backround_color
                                                                                : '#DEEEE2'
                                                                    }"
                                                                    class="mx-3 subCategory-label-text"
                                                                    *ngIf="
                                                                        lang ===
                                                                            'en' &&
                                                                        levelThreeItem.subCategory_label_text_en
                                                                    "
                                                                >
                                                                    {{
                                                                        levelThreeItem.subCategory_label_text_en
                                                                    }}
                                                                </span>
                                                                <span
                                                                    [ngStyle]="{
                                                                        color: levelThreeItem?.subCategory_label_text_color
                                                                            ? levelThreeItem?.subCategory_label_text_color
                                                                            : '#248A3D',
                                                                        background:
                                                                            levelThreeItem?.subCategory_label_text_backround_color
                                                                                ? levelThreeItem?.subCategory_label_text_backround_color
                                                                                : '#DEEEE2'
                                                                    }"
                                                                    class="mx-3 subCategory-label-text"
                                                                    *ngIf="
                                                                        levelThreeItem.subCategory_label_text_ar &&
                                                                        lang ===
                                                                            'ar'
                                                                    "
                                                                >
                                                                    {{
                                                                        levelThreeItem.subCategory_label_text_ar
                                                                    }}
                                                                </span>
                                                            </ng-template>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <ng-container
                                        *ngIf="
                                            levelOneItem.level1_image &&
                                            levelOneItem?.level1_gallery_images
                                                ?.length > 0
                                        "
                                    >
                                        <h5 class="title-prands-small">
                                            {{
                                                lang == "en"
                                                    ? levelOneItem?.galery_name_en
                                                    : levelOneItem?.galery_name_ar
                                            }}
                                        </h5>

                                        <div
                                            style="margin-top: 0 !important"
                                            class="gallery-images my-3"
                                        >
                                            <div
                                                *ngFor="
                                                    let img of levelOneItem?.level1_gallery_images
                                                "
                                                class="single-gallery-image"
                                            >
                                                <img
                                                    loading="lazy"
                                                    *ngIf="img?.image"
                                                    [src]="img?.image"
                                                    [ngClass]="{
                                                        'curoser-pointer':
                                                            img?.url &&
                                                            img?.url?.length > 0
                                                    }"
                                                    (click)="
                                                        img?.url &&
                                                        img?.url?.length > 0
                                                            ? navigateToLink(
                                                                  img?.url
                                                              )
                                                            : null
                                                    "
                                                    onError="this.src='./assets/images/placeholder200.jpg';"
                                                    alt="image"
                                                />
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                                <ng-container>
                                    <ng-container
                                        *ngIf="levelOneItem.level1_image"
                                    >
                                        <div
                                            class="first-level-image"
                                            [ngStyle]="{
                                                'min-width':
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric,
                                                'max-width':
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric,
                                                width:
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric
                                            }"
                                        >
                                            <img
                                                loading="lazy"
                                                [src]="levelOneItem.image"
                                                alt="main section image"
                                                onError="this.src='./assets/images/placeholder200.jpg';"
                                                default="./assets/images/placeholder200.jpg"
                                            />
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="
                                            !levelOneItem.level1_image &&
                                            levelOneItem?.level1_gallery_images
                                                ?.length > 0
                                        "
                                    >
                                        <h5 class="title-prands">
                                            {{
                                                lang == "en"
                                                    ? levelOneItem?.galery_name_en
                                                    : levelOneItem?.galery_name_ar
                                            }}
                                        </h5>
                                        <div class="gallery-images my-3">
                                            <div
                                                *ngFor="
                                                    let img of levelOneItem?.level1_gallery_images
                                                "
                                                class="single-gallery-image"
                                            >
                                                <img
                                                    loading="lazy"
                                                    *ngIf="img?.image"
                                                    [src]="img?.image"
                                                    [ngClass]="{
                                                        'curoser-pointer':
                                                            img?.url &&
                                                            img?.url?.length > 0
                                                    }"
                                                    (click)="
                                                        img?.url &&
                                                        img?.url?.length > 0
                                                            ? navigateToLink(
                                                                  img?.url
                                                              )
                                                            : null
                                                    "
                                                    onError="this.src='./assets/images/placeholder200.jpg';"
                                                    alt="image"
                                                />
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-template #simpleMenu>
                                <ul
                                    class="sub-menu-items-container simple-sub-menu"
                                >
                                    <li
                                        class="sub-level-items-container"
                                        *ngFor="
                                            let levelTwoItem of levelOneItem.level2
                                        "
                                    >
                                        <div class="sub-level-items">
                                            <div class="menu-section-body">
                                                <p
                                                    class="second-level-nav-link"
                                                    (click)="
                                                        navigateToLink(
                                                            levelTwoItem.link,
                                                            levelOneItem.link,
                                                            levelOneItem
                                                        )
                                                    "
                                                >
                                                    {{
                                                        (lang == "en"
                                                            ? levelTwoItem?.name
                                                            : levelTwoItem?.name_ar
                                                        ) | translate
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div
                                    class="first-level-image"
                                    [ngStyle]="{
                                        'min-width':
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric,
                                        'max-width':
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric,
                                        width:
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric
                                    }"
                                    *ngIf="levelOneItem.level1_image"
                                >
                                    <img
                                        loading="lazy"
                                        [src]="levelOneItem.image"
                                        alt="main section image"
                                        onError="this.src='./assets/images/placeholder200.jpg';"
                                        default="./assets/images/placeholder200.jpg"
                                    />
                                </div>
                            </ng-template>
                        </div>
                    </li>
                </ul>
            </nav>
            <nav
                class="app-nav"
                *ngIf="!loadingMenu && testData"
                [ngClass]="{
                    'd-none':
                        environmentVariables?.ENABLE_MENU_AS_CARDS && showcards
                }"
                (click)="updateColorsTest()"
            >
                <ul
                    id="app-nav-list-menu2"
                    class="app-nav-list my-0"
                    [ngClass]="{
                        'hide-menu': clickedItem
                    }"
                    (mouseleave)="clickedItem = false"
                >
                    <li
                        class="app-nav-item"
                        [ngClass]="{
                            mega: levelOneItem?.level2?.length > 0
                        }"
                        *ngFor="
                            let levelOneItem of testData.level1;
                            let i = index
                        "
                    >
                        <div class="single-card-menu text-with-lable">
                            <a
                                class="nav-link main has-link"
                                [ngClass]="{
                                    'px-2':
                                        levelOneItem.label_text_en &&
                                        levelOneItem.label_text_ar
                                }"
                                routerLinkActive="active-link"
                                (click)="navigateToLink(levelOneItem.link)"
                                (mouseleave)="clickedItem = false"
                            >
                                <span class="">
                                    {{
                                        lang == "en"
                                            ? levelOneItem?.name
                                            : levelOneItem?.name_ar
                                    }}
                                </span>
                            </a>

                            <span
                                style="position: unset"
                                [ngStyle]="{
                                    color: levelOneItem?.label_text_color
                                        ? levelOneItem?.label_text_color
                                        : '#248A3D',
                                    background:
                                        levelOneItem?.label_text_backround_color
                                            ? levelOneItem?.label_text_backround_color
                                            : '#DEEEE2'
                                }"
                                class="card-menu-label fs-12"
                                *ngIf="
                                    levelOneItem.label_text_en && lang === 'en'
                                "
                            >
                                {{ levelOneItem.label_text_en }}
                            </span>
                            <span
                                style="position: unset"
                                [ngStyle]="{
                                    color: levelOneItem?.label_text_color
                                        ? levelOneItem?.label_text_color
                                        : '#248A3D',
                                    background:
                                        levelOneItem?.label_text_backround_color
                                            ? levelOneItem?.label_text_backround_color
                                            : '#DEEEE2'
                                }"
                                class="card-menu-label fs-12"
                                *ngIf="
                                    levelOneItem.label_text_ar && lang === 'ar'
                                "
                            >
                                {{ levelOneItem.label_text_ar }}
                            </span>
                        </div>

                        <div
                            class="sub-menu main-submenu dynamic-menu"
                            [ngClass]="{
                                'sub-menu-ar': lang == 'ar',
                                'box-shaow-none':
                                    environmentVariables?.ENABLE_MENU_AS_CARDS,
                                'sub-menu-left':
                                    levelOneItem.menu_fixed_width > 95
                            }"
                            [ngStyle]="{
                                padding:
                                    levelOneItem.menu_padding +
                                    levelOneItem.menu_padding_metric,
                                width:
                                    levelOneItem.menu_fixed_width +
                                    levelOneItem.menu_fixed_width_metric
                            }"
                        >
                            <ng-container
                                *ngIf="
                                    levelOneItem?.level2?.length > 0 &&
                                        levelOneItem?.levels_length == 3;
                                    else simpleMenu
                                "
                            >
                                <div class="menu-items">
                                    <ul
                                        class="sub-menu-items-container"
                                        [ngClass]="{
                                            'submenu-with-gallery':
                                                levelOneItem?.level1_gallery_images &&
                                                levelOneItem
                                                    ?.level1_gallery_images
                                                    ?.length > 0
                                        }"
                                    >
                                        <li
                                            class="sub-level-items-container"
                                            [ngClass]="
                                                levelOneItem.fixed_width
                                                    ? 'fixed-width'
                                                    : ''
                                            "
                                            [ngStyle]="{
                                                width:
                                                    levelOneItem.fixed_width +
                                                    levelOneItem.fixed_width_metric
                                            }"
                                            *ngFor="
                                                let levelTwoItem of levelOneItem.level2;
                                                index as i
                                            "
                                        >
                                            <div class="sub-level-items">
                                                <img
                                                    loading="lazy"
                                                    *ngIf="
                                                        levelOneItem.level2_image &&
                                                        levelTwoItem.image
                                                    "
                                                    [src]="levelTwoItem.image"
                                                    alt="secondary section image"
                                                />
                                                <div class="menu-section-body">
                                                    <div class="mb-2 position-relative" fxLayout="row" fxLayoutAlign="center center">
                                                        <span
                                                            fxFlex
                                                            class="second-level-nav-link"
                                                            [ngClass]="{
                                                                'has-link':
                                                                    levelTwoItem.link,
                                                                'config-font-family':
                                                                    environmentVariables?.ENABLE_FONT_FAMILY_OVERWRITE &&
                                                                    lang == 'en'
                                                            }"
                                                            (click)="
                                                                (!environmentVariables?.ENABLE_COLLAPSE_GROUPS_FOR_MENU_CREATORS ||
                                                                !levelTwoItem?.level3?.length) &&
                                                                navigateToLink(
                                                                    levelTwoItem.link,
                                                                    levelOneItem.link,
                                                                    levelOneItem,
                                                                    'group'
                                                                );
                                                                environmentVariables?.ENABLE_COLLAPSE_GROUPS_FOR_MENU_CREATORS &&
                                                                levelTwoItem?.level3?.length &&
                                                                toggleCollapsedMenu(
                                                                    (levelTwoItem.id ? 
                                                                        '#list-' + levelTwoItem.id : 
                                                                        '#' + levelTwoItem.slug))
                                                            "
                                                        >
                                                            <span
                                                                class="level-tow-text"
                                                            >
                                                                {{
                                                                    (lang == "en"
                                                                        ? levelTwoItem?.name
                                                                        : levelTwoItem?.name_ar
                                                                    ) | translate
                                                                }}
                                                            </span>
                                                            <span
                                                                [ngStyle]="{
                                                                    color: levelTwoItem?.group_label_text_color
                                                                        ? levelTwoItem?.group_label_text_color
                                                                        : '#248A3D',
                                                                    background:
                                                                        levelTwoItem?.group_label_text_backround_color
                                                                            ? levelTwoItem?.group_label_text_backround_color
                                                                            : '#DEEEE2'
                                                                }"
                                                                class="mx-3 group-label-text"
                                                                *ngIf="
                                                                    levelTwoItem.group_label_text_ar &&
                                                                    lang === 'ar'
                                                                "
                                                            >
                                                                {{
                                                                    levelTwoItem.group_label_text_ar
                                                                }}
                                                            </span>
                                                            <span
                                                                [ngStyle]="{
                                                                    color: levelTwoItem?.group_label_text_color
                                                                        ? levelTwoItem?.group_label_text_color
                                                                        : '#248A3D',
                                                                    background:
                                                                        levelTwoItem?.group_label_text_backround_color
                                                                            ? levelTwoItem?.group_label_text_backround_color
                                                                            : '#DEEEE2'
                                                                }"
                                                                class="mx-3 group-label-text"
                                                                *ngIf="
                                                                    lang === 'en' &&
                                                                    levelTwoItem.group_label_text_en
                                                                "
                                                            >
                                                                {{
                                                                    levelTwoItem.group_label_text_en
                                                                }}
                                                            </span>
                                                        </span>
    
                                                        <mat-icon
                                                            *ngIf="
                                                                environmentVariables?.ENABLE_COLLAPSE_GROUPS_FOR_MENU_CREATORS && levelTwoItem?.level3?.length
                                                            "
                                                            fxFlex="auto"
                                                            class="material-icons pointer"
                                                            aria-hidden="false"
                                                        >
                                                            expand_more
                                                        </mat-icon>
                                                    </div>

                                                    <ul class="mt-4" 
                                                        [id]="
                                                            levelTwoItem.id ? 
                                                                'list-' + levelTwoItem.id : 
                                                                levelTwoItem.slug
                                                        "
                                                        [ngStyle]="{
                                                            'display': environmentVariables?.ENABLE_COLLAPSE_GROUPS_FOR_MENU_CREATORS ? 'none' : ''
                                                        }"
                                                    >
                                                        <li
                                                            class="third-level-nav-link"
                                                            [ngStyle]="{
                                                                'line-height':
                                                                    levelOneItem.level3_items_spacing +
                                                                    levelOneItem.level3_items_spacing_metric
                                                            }"
                                                            *ngFor="
                                                                let levelThreeItem of levelTwoItem.level3
                                                            "
                                                            (click)="
                                                                navigateToLink(
                                                                    levelThreeItem.link,
                                                                    null,
                                                                    levelOneItem,
                                                                    'sub'
                                                                )
                                                            "
                                                            [ngClass]="{
                                                                'has-link':
                                                                    levelThreeItem.link
                                                            }"
                                                        >
                                                            <div
                                                                class="view-more"
                                                                *ngIf="
                                                                    levelThreeItem.highlighted;
                                                                    else seeMoreLink
                                                                "
                                                            >
                                                                <img
                                                                    loading="lazy"
                                                                    *ngIf="
                                                                        levelOneItem.level3_image &&
                                                                        levelThreeItem.image
                                                                    "
                                                                    [src]="
                                                                        levelThreeItem.image
                                                                    "
                                                                    alt="item images"
                                                                />
                                                                <!-- - -->
                                                                {{
                                                                    (lang ==
                                                                    "en"
                                                                        ? levelThreeItem?.name
                                                                        : levelThreeItem?.name_ar
                                                                    )
                                                                        | translate
                                                                }}
                                                            </div>
                                                            <ng-template
                                                                #seeMoreLink
                                                            >
                                                                <img
                                                                    loading="lazy"
                                                                    *ngIf="
                                                                        levelOneItem.level3_image &&
                                                                        levelOneItem.level3_image &&
                                                                        levelThreeItem.image
                                                                    "
                                                                    [src]="
                                                                        levelThreeItem.image
                                                                    "
                                                                    alt="item images"
                                                                />
                                                                {{
                                                                    (lang ==
                                                                    "en"
                                                                        ? levelThreeItem?.name
                                                                        : levelThreeItem?.name_ar
                                                                    )
                                                                        | translate
                                                                }}
                                                                <span
                                                                    [ngStyle]="{
                                                                        color: levelThreeItem?.subCategory_label_text_color
                                                                            ? levelThreeItem?.subCategory_label_text_color
                                                                            : '#248A3D',
                                                                        background:
                                                                            levelThreeItem?.subCategory_label_text_backround_color
                                                                                ? levelThreeItem?.subCategory_label_text_backround_color
                                                                                : '#DEEEE2'
                                                                    }"
                                                                    class="mx-3 subCategory-label-text"
                                                                    *ngIf="
                                                                        lang ===
                                                                            'en' &&
                                                                        levelThreeItem.subCategory_label_text_en
                                                                    "
                                                                >
                                                                    {{
                                                                        levelThreeItem.subCategory_label_text_en
                                                                    }}
                                                                </span>
                                                                <span
                                                                    [ngStyle]="{
                                                                        color: levelThreeItem?.subCategory_label_text_color
                                                                            ? levelThreeItem?.subCategory_label_text_color
                                                                            : '#248A3D',
                                                                        background:
                                                                            levelThreeItem?.subCategory_label_text_backround_color
                                                                                ? levelThreeItem?.subCategory_label_text_backround_color
                                                                                : '#DEEEE2'
                                                                    }"
                                                                    class="mx-3 subCategory-label-text"
                                                                    *ngIf="
                                                                        lang ==
                                                                            'ar' &&
                                                                        levelThreeItem.subCategory_label_text_ar
                                                                    "
                                                                >
                                                                    {{
                                                                        levelThreeItem.subCategory_label_text_ar
                                                                    }}
                                                                </span>
                                                            </ng-template>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                    <ng-container
                                        *ngIf="
                                            levelOneItem.level1_image &&
                                            levelOneItem?.level1_gallery_images
                                                ?.length > 0
                                        "
                                    >
                                        <h5 class="title-prands-small">
                                            {{
                                                lang == "en"
                                                    ? levelOneItem?.galery_name_en
                                                    : levelOneItem?.galery_name_ar
                                            }}
                                        </h5>
                                        <div
                                            class="gallery-images my-3"
                                            style="
                                                margin-top: 0 !important
                                        ;
                                            "
                                        >
                                            <div
                                                *ngFor="
                                                    let img of levelOneItem?.level1_gallery_images
                                                "
                                                class="single-gallery-image"
                                            >
                                                <img
                                                    loading="lazy"
                                                    *ngIf="img?.image"
                                                    [src]="img?.image"
                                                    [ngClass]="{
                                                        'curoser-pointer':
                                                            img?.url &&
                                                            img?.url?.length > 0
                                                    }"
                                                    (click)="
                                                        img?.url &&
                                                        img?.url?.length > 0
                                                            ? navigateToLink(
                                                                  img?.url
                                                              )
                                                            : null
                                                    "
                                                    onError="this.src='./assets/images/placeholder200.jpg';"
                                                    [alt]="img?.name"
                                                />
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                                <ng-container>
                                    <ng-container
                                        *ngIf="levelOneItem.level1_image"
                                    >
                                        <div
                                            class="first-level-image"
                                            [ngStyle]="{
                                                'min-width':
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric,
                                                'max-width':
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric,
                                                width:
                                                    levelOneItem.level1_image_dimentions +
                                                    levelOneItem.level1_image_dimentions_metric
                                            }"
                                        >
                                            <img
                                                loading="lazy"
                                                [src]="levelOneItem.image"
                                                alt="main section image"
                                                onError="this.src='./assets/images/placeholder200.jpg';"
                                                default="./assets/images/placeholder200.jpg"
                                            />
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="
                                            !levelOneItem.level1_image &&
                                            levelOneItem?.level1_gallery_images
                                                ?.length > 0
                                        "
                                    >
                                        <h5 class="title-prands">
                                            {{
                                                lang == "en"
                                                    ? levelOneItem?.galery_name_en
                                                    : levelOneItem?.galery_name_ar
                                            }}
                                        </h5>
                                        <div class="gallery-images my-3">
                                            <div
                                                *ngFor="
                                                    let img of levelOneItem?.level1_gallery_images
                                                "
                                                class="single-gallery-image"
                                            >
                                                <img
                                                    loading="lazy"
                                                    *ngIf="img?.image"
                                                    [src]="img?.image"
                                                    [ngClass]="{
                                                        'curoser-pointer':
                                                            img?.url &&
                                                            img?.url?.length > 0
                                                    }"
                                                    (click)="
                                                        img?.url &&
                                                        img?.url?.length > 0
                                                            ? navigateToLink(
                                                                  img?.url
                                                              )
                                                            : null
                                                    "
                                                    onError="this.src='./assets/images/placeholder200.jpg';"
                                                    [alt]="img?.name"
                                                />
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-template #simpleMenu>
                                <ul
                                    class="sub-menu-items-container simple-sub-menu"
                                >
                                    <li
                                        class="sub-level-items-container"
                                        *ngFor="
                                            let levelTwoItem of levelOneItem.level2
                                        "
                                    >
                                        <div class="sub-level-items">
                                            <div class="menu-section-body">
                                                <p
                                                    class="second-level-nav-link"
                                                    (click)="
                                                        navigateToLink(
                                                            levelTwoItem.link,
                                                            levelOneItem.link,
                                                            levelOneItem
                                                        )
                                                    "
                                                >
                                                    {{
                                                        (lang == "en"
                                                            ? levelTwoItem?.name
                                                            : levelTwoItem?.name_ar
                                                        ) | translate
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div
                                    class="first-level-image"
                                    [ngStyle]="{
                                        'min-width':
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric,
                                        'max-width':
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric,
                                        width:
                                            levelOneItem.level1_image_dimentions +
                                            levelOneItem.level1_image_dimentions_metric
                                    }"
                                    *ngIf="levelOneItem.level1_image"
                                >
                                    <img
                                        loading="lazy"
                                        [src]="levelOneItem.image"
                                        alt="main section image"
                                        onError="this.src='./assets/images/placeholder200.jpg';"
                                        default="./assets/images/placeholder200.jpg"
                                    />
                                </div>
                            </ng-template>
                        </div>
                    </li>
                </ul>
            </nav>
            <nav class="app-nav" *ngIf="loadingMenu">
                <ul class="app-nav-list">
                    <li class="app-nav-item" *ngFor="let fake of fakeArray">
                        <div
                            class="animate-shimmer shimmer-container"
                            [ngClass]="{
                                'shimmer-container-menu-cart':
                                    environmentVariables?.ENABLE_MENU_AS_CARDS
                            }"
                        ></div>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</ng-container>
